module.exports = __webpack_public_path__ + "img/WechatIMG30253.83b3afed.jpg";